import { isCamaraVisibleParaCliente } from '../../utils/camaraStatus';
import React, { useState, useEffect } from 'react';
import useBreakpoint from '../../hooks/useBreakpoint';
import '../style/CustomerDashboard.css';
import { FloatingWhatsAppButton } from './../../whatsapp/components/WhatsAppComponents';
import Sidebar from './CustomerSidebar';
import LoadingSpinner from '../utils/LoadingSpinner';
import { Eye, EyeOff } from 'lucide-react';

import { Menu, Loader } from "lucide-react"; 
import logo from "../../media/lisualpro.png"; 
import defaultCustomerLogo from "../../media/lisualLogo.jpg";
import { useNavigate, useParams } from "react-router-dom";
import { db } from '../../firebase-config';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ArrowRight, Info, Share2, Download } from 'lucide-react'; 
import OnboardingAndDeliveryScheduleStart from './OnboardingAndDeliveryScheduleStart.tsx';
import { set } from 'lodash';
import { updateUser, getUsersByCustomerId } from "../api/users.api.js";
import { getProjectsByCustomerId } from '../api/Customer.api.js';
import ProjectLastFrameImage from './ProjectLastFrameImage.js';
import { getRotationDegrees, computeOrientedImageStyle } from '../../utils/cameraOrientation.js';


const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8081';


function CustomerDashboardStart() {
  const [projects, setProjects] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const { isTablet } = useBreakpoint();
  // On tablets the sidebar is an overlay drawer, so start it closed
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isTablet);
  const [activeTab, setActiveTab] = useState("Inicio");

  const customerId = useParams();

  const [isLoadingContent, setIsLoadingContent] = useState(true);

  const [isLoadingCustomer, setIsLoadingCustomer] = useState(true);
  const [isLoadingProjects, setIsLoadingProjects] = useState(true);
  const [isLoadingLogo, setIsLoadingLogo] = useState(true);

  const [imageOrientations, setImageOrientations] = useState({});
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const [ftps3ImageUrls, setFtps3ImageUrls] = useState({});
  const [imageRetryCounts, setImageRetryCounts] = useState({});
  const [imageErrorStates, setImageErrorStates] = useState({});
  const MAX_IMAGE_RETRIES = 2;
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [modalOnboardOpen, setModalOnboardOpen] = useState(false);
    const [isStartBoxVisible, setStartBoxVisible] = useState(false);
    const [force, setForce] = useState(false);

    const [isAdminChoiceMade, setIsAdminChoiceMade] = useState(false);
  const [isAdministrator, setIsAdministrator] = useState(null);
  const [isIdentifierVisible, setIsIdentifierVisible] = useState(false);
  const VisibilityIcon = isIdentifierVisible ? EyeOff : Eye;

  

    const fetchSingleFtps3ImageUrl = async (projectId, feedID) => {
      const token = localStorage.getItem("authLisualToken");

      try {
        const response = await fetch(
            `https://webback.lisual.com/api/s3-images/${feedID}/latest`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
        );

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        let imageUrl = null;
        const clonedResponse = response.clone();

        try {
          const data = await response.json();
          imageUrl = data?.url;
        } catch (jsonError) {
          imageUrl = await clonedResponse.text();
        }

        if (imageUrl) {
          setFtps3ImageUrls((prev) => ({
            ...prev,
            [projectId]: imageUrl,
          }));

          setImageLoadingStates((prev) => ({
            ...prev,
            [projectId]: true,
          }));
          return true;
        }
        return false;
      } catch (error) {
        console.error(`Error fetching FTPS3 image URL for ${feedID}:`, error);
        return false;
      }
    };

    const fetchProjects = async () => {
      try {
        const projectsData = await getProjectsByCustomerId(customerId.customerId);
        setProjects(projectsData.filter(isCamaraVisibleParaCliente));

        const initialLoadingStates = {};
        const newFtps3ImageUrls = {};
        const newRetryCounts = {};
        const newImageErrors = {};

        const token = localStorage.getItem("authLisualToken");

        for (const project of projectsData) {
          initialLoadingStates[project.id] = false;
          newRetryCounts[project.id] = 0;
          newImageErrors[project.id] = false;

          if (!project?.feedID || project?.feedID === 'null') {
            continue;
          }

          initialLoadingStates[project.id] = true;
          try {
            const response = await fetch(
                `https://webback.lisual.com/api/s3-images/${project.feedID}/latest`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
            );

            if (!response.ok) {
              throw new Error(`HTTP ${response.status}`);
            }

            let imageUrl = null;
            const clonedResponse = response.clone();

            try {
              const data = await response.json();
              imageUrl = data?.url;
            } catch (jsonError) {
              imageUrl = await clonedResponse.text();
            }

            if (imageUrl) {
              newFtps3ImageUrls[project.id] = imageUrl;
            } else {
              newImageErrors[project.id] = true;
              initialLoadingStates[project.id] = false;
            }

          } catch (err) {
            console.error(`FTPS3 fetch error for ${project.feedID}:`, err);
            newImageErrors[project.id] = true;
            initialLoadingStates[project.id] = false;
          }
        }

        setFtps3ImageUrls(newFtps3ImageUrls);
        setImageRetryCounts(newRetryCounts);
        setImageErrorStates(newImageErrors);
        setImageLoadingStates((prev) => ({
          ...prev,
          ...initialLoadingStates,
        }));

      } catch (error) {
        console.error("Error fetching projects:", error);
        toast.error('Error al cargar los proyectos.');
      } finally {
        setIsLoadingProjects(false);
      }
  }

  useEffect(() => {
    if (customerId) {
      fetchProjects();
    }
  }, [force]);


  useEffect(() => {
    const fetchCustomerData = async () => {
      const q = query(collection(db, "customers"), where("customerId", "==", customerId.customerId));
      try {
        const querySnapshot = await getDocs(q);
        const customerData = [];
        querySnapshot.forEach((doc) => {
          customerData.push({ ...doc.data() });
        });
        setCustomerData(customerData);
      } catch (error) {
        console.error("Error fetching customer data:", error);
      } finally {
        setIsLoadingCustomer(false);
      }
    };
    if (customerId) {
      fetchCustomerData();
    }
  }, [force]);


useEffect(() => {
    if (!isLoadingCustomer && !isLoadingProjects) {
        setIsLoadingContent(false);
    } else {
        setIsLoadingContent(true);
    }
}, [isLoadingCustomer, isLoadingProjects]);


useEffect(() => {
  if (!isLoadingCustomer) {
    setIsLoadingLogo(false);
  }
}, [isLoadingCustomer]);


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };


  const handleSetActiveTab = (tabName) => {
    setActiveTab(tabName);
  };


  const handleIngresar = (identifier) => {
    navigate(`/dashboard/${identifier}`, '_blank');
  };

  const handleDetails = (projectId) => {
    toast.info(`Ver detalles del proyecto: ${projectId}`);
  };

  const handleShare = (projectId) => {
    toast.info(`Compartir proyecto: ${projectId}`);
  };

  const handleDownload = (projectId) => {
    toast.info(`Descargar proyecto: ${projectId}`);
  };

   const handleImageLoad = (e, projectId) => {
    const img = e.target;
    const wrapper = img.parentElement;
    const rotationDeg = getRotationDegrees(projects.find(p => p.id === projectId)?.orientation);
    const orientation = computeOrientedImageStyle({
      rotationDeg,
      naturalWidth: img.naturalWidth,
      naturalHeight: img.naturalHeight,
      containerWidth: wrapper?.clientWidth || img.clientWidth,
      containerHeight: wrapper?.clientHeight || img.clientHeight,
    });
    setImageOrientations(prev => ({
      ...prev,
      [projectId]: orientation
    }));
    setImageLoadingStates(prev => ({
      ...prev,
      [projectId]: false
    }));
    setImageErrorStates(prev => ({
      ...prev,
      [projectId]: false,
    }));
    setImageRetryCounts(prev => ({
      ...prev,
      [projectId]: 0,
    }));
  };

  const handleImageError = async (projectId, project) => {
    const currentRetries = imageRetryCounts[projectId] || 0;

    if (currentRetries < MAX_IMAGE_RETRIES) {
      setImageRetryCounts(prev => ({
        ...prev,
        [projectId]: currentRetries + 1
      }));

      const success = await fetchSingleFtps3ImageUrl(projectId, project.feedID);

      if (success) {
        return;
      }
    }

    setImageLoadingStates((prev) => ({
      ...prev,
      [projectId]: false,
    }));

    setImageErrorStates((prev) => ({
      ...prev,
      [projectId]: true,
    }));
  };

  
  useEffect(() => {
    if (customerData.length > 0 && customerData[0].logo) {
      setIsLoadingLogo(false);
    }
  }, [customerData]);



  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
      setStartBoxVisible(true); 
    }, 4000); // 4 segundos

    return () => clearTimeout(timer);
  }, []);


  const identifier = customerId.identifier
  

  if (isLoading) {
    return (
        <>
            <div className="flex flex-col justify-center items-center h-screen">
                <div className="mb-4">
                <LoadingSpinner />
                </div>
                <div>
                <p className="text-lg font-bold text-gray-800">Tu pago se está procesando...</p>
                </div>
            </div>
        </>
    );
  }

 if (isStartBoxVisible) {


  const getInvitationLink = () => {
    if(API_URL == "http://localhost:8081"){
      return `http://localhost:3002/createUniqueResponsibleUserUsingURL/${customerId.customerId}/j3d1e54ujnn178102nc332f38921dg`;
    } else {
      return `http://pro.lisual.com/createUniqueResponsibleUserUsingURL/${customerId.customerId}/j3d1e54ujnn178102nc332f38921dg`;
    }
  }

  const invitationLink = getInvitationLink();

  const handleAdminChoice = async (choice) => {
  setIsAdministrator(choice);
  setIsAdminChoiceMade(true);

  if (choice === true) {
    console.log("El usuario decidió ser Administrador.");

    try {
      // 1️⃣ Buscar el usuario asociado a este customerId
      const users = await getUsersByCustomerId(customerId.customerId);

      if (!users || users.length === 0) {
        toast.error("No se encontró ningún usuario para este cliente.");
        return;
      }

      // 2️⃣ Tomar el usuario que queremos actualizar
      const userToUpdate = users[0]; // el primero (es único en tu caso)

      // 3️⃣ Actualizar rol del usuario
      await updateUser(userToUpdate.id, { role: "responsibleUser" });

      toast.success("Ahora eres el administrador de la plataforma.");
      
    } catch (error) {
      console.error("Error al asignar administrador:", error);
      toast.error("No se pudo asignar el rol de administrador.");
    }
  } else {
    console.log("El usuario NO será Administrador.");
  }
};


  const displayIdentifier = isIdentifierVisible 
      ? identifier 
      : '********';

      

  return (
    // Contenedor principal para centrar en pantalla
    <div className="flex flex-col justify-center items-center h-screen bg-gray-50 p-4">
      {/* Card o Caja de Bienvenida/Configuración Inicial */}
      <div className="bg-white rounded-xl shadow-2xl p-8 max-w-lg w-full text-center border border-gray-100">

        <h1 className="text-3xl font-extrabold text-blue-600 mb-6">
          🎉 ¡Primeros Pasos!
        </h1>

        {/* Sección de Credenciales */}
        <div className="mb-8 border-b pb-6">
            <p className="text-lg text-gray-700 mb-2">
              Tu contraseña de inicio es:
            </p>
            
            {/* Contenedor del identificador y el botón de ojo */}
            <div className="flex justify-center items-center space-x-2"> 
              <div className="inline-block px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg">
                <strong className="text-2xl font-mono text-gray-900 tracking-wider">
                  {/* ✨ Se renderiza el valor enmascarado/visible */}
                  {displayIdentifier}
                </strong>
              </div>
              
              {/* ✨ Botón/Icono de Toggle */}
              <button
                onClick={() => setIsIdentifierVisible(!isIdentifierVisible)}
                className="p-2 rounded-full text-gray-600 hover:bg-gray-100 transition duration-150"
                title={isIdentifierVisible ? "Ocultar contraseña" : "Mostrar contraseña"}
              >
                <VisibilityIcon size={24} />
              </button>
            </div> {/* Fin de flex */}
          <p className="text-sm text-gray-500 mt-3">
            Úsala junto a tu mail para ingresar desde <strong className="font-semibold text-gray-700">pro.lisual.com</strong>. Podrás cambiarla luego desde el panel de usuarios.
          </p>
        </div>

        {/* --- SECCIÓN DE ELECCIÓN DEL ADMINISTRADOR --- */}
        {/* Mostrar solo si aún no se ha tomado una decisión */}
        {!isAdminChoiceMade && (
            <div className="mb-8 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <p className="text-xl font-bold text-gray-800 mb-4">
                ¿Deseas ser el <span className="text-blue-600">administrador</span> de la plataforma?
              </p>
              
              {/* Botones de SI/NO */}
              <div className="flex justify-center space-x-4">
                {/* Botón SI */}
                <button
                  onClick={() => handleAdminChoice(true)}
                  className="flex-1 px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition duration-200 shadow-md shadow-blue-300/50"
                >
                  Sí, ser administrador
                </button>

                {/* Botón NO (Lógica de URL) */}
                <button
                  onClick={() => handleAdminChoice(false)}
                  className="flex-1 px-6 py-3 bg-gray-200 text-gray-800 font-semibold rounded-lg hover:bg-gray-300 transition duration-200"
                >
                  No
                </button>
              </div>
            </div>
        )}
        
        {/* --- SECCIÓN DE URL DE INVITACIÓN (MUESTRA si isAdminChoiceMade es true y isAdministrator es false) --- */}
        {isAdminChoiceMade && !isAdministrator && (
          <div className="mb-8 p-6 bg-yellow-50 rounded-lg border border-yellow-200 text-left">
            <p className="text-lg font-bold text-yellow-800 mb-3 flex items-center">
              🔗 Compartir Enlace de Invitación
            </p>
            <p className="text-sm text-gray-700 mb-4">
              Pega este enlace único y compártelo con la persona que será el <strong>Administrador</strong> de la plataforma. Una vez que ingrese, se le asignará el rol automáticamente.
            </p>
            
            {/* Campo de URL */}
            <div className="relative">
              <input
                type="text"
                readOnly
                value={invitationLink}
                className="w-full p-3 pr-16 text-sm bg-white border border-yellow-300 rounded-lg font-mono text-gray-900 overflow-x-auto whitespace-nowrap"
              />
              <button
                onClick={() => {
                  navigator.clipboard.writeText(invitationLink);
                  toast.success("¡Enlace copiado al portapapeles!"); 
                }}
                className="absolute right-1 top-1/2 transform -translate-y-1/2 p-2 bg-yellow-600 text-white rounded-md hover:bg-yellow-700 transition"
                title="Copiar enlace"
              >
                Copiar
              </button>
            </div>
          </div>
        )}


        {/* Sección de Continuar (Visible solo después de tomar una decisión) */}
        <div className={`mt-8 border-t pt-6 ${!isAdminChoiceMade ? 'hidden' : ''}`}>
             <p className="text-md text-gray-600 mb-4">
               A continuación, podrás agendar las reuniones de integración.
             </p>
            <button
              onClick={() => {
                setModalOnboardOpen(true);
                setStartBoxVisible(false);
              }}
              className="w-full py-3 bg-green-500 text-white text-lg font-bold rounded-lg hover:bg-green-600 transition duration-200 shadow-lg shadow-green-300/50"
              // Deshabilitar si aún no se ha tomado una decisión (opcional)
              // disabled={!isAdminChoiceMade}
            >
              Continuar
            </button>
        </div>
      </div>
      <ToastContainer/>
    </div>

  );
}





  return (
    <>
      <div className="flex h-dvh min-h-0 overflow-hidden bg-gray-100">
        <Sidebar
          isSidebarOpen={isSidebarOpen}
          toggleSidebar={toggleSidebar}
          activeTab={activeTab}
          setActiveTab={handleSetActiveTab}
          logo={customerData.length > 0 && customerData[0].logo ? customerData[0].logo : defaultCustomerLogo}
          isLoadingLogo={isLoadingLogo}
          customerId={customerId.customerId}
          onProjectCreated={fetchProjects}

        />

        <div className="lg:hidden fixed top-0 left-0 right-0 z-30 bg-white border-b border-gray-200 shadow-sm">
          <div className="flex items-center justify-between px-4 py-3">
            {isLoadingLogo ? (
              <p className="text-center text-gray-500">Cargando...</p>
            ) : (
              customerData.length > 0 && customerData[0].logo ? (
                <img src={customerData[0].logo} alt="Logo" className="max-h-12 w-auto" />
              ) : (
                null 
              )
            )}
            <button
              onClick={toggleSidebar}
              className="p-2.5 rounded-lg hover:bg-gray-100 transition-colors"
            >
              <Menu size={24} className="text-gray-600" />
            </button>
          </div>
        </div>

        <div className={`flex-1 flex flex-col min-h-0 ${isSidebarOpen ? "lg:ml-64" : "lg:ml-0"}`}>
          <FloatingWhatsAppButton message="Tengo una consulta." className="z-40" />

          <main className="flex-1 min-h-0 w-full overflow-y-auto bg-gray-100 p-3 md:p-6 mt-14 lg:mt-0">
            <div className="dashboard-container">

            {isLoadingContent ? (
              <div className="flex justify-center items-center h-full min-h-[300px]">
                <Loader size={48} className="animate-spin text-blue-500" />
              </div>
            ) : (
              <>
                <h1>
                  <strong>Bienvenido/a: </strong>{customerData[0]?.name ?? 'Cliente desconocido'}
                </h1>

                <br />

                <div className="project-grid">
                    {projects.map((project) => (
                      <div key={project.id} className="project-card">
                        <div className={`project-image-wrapper ${imageOrientations[project.id]?.isVertical ? 'bg-black' : 'bg-white'}`}>
                          {!imageErrorStates[project.id] ? (
                            <ProjectLastFrameImage
                              project={project}
                              ftps3ImageUrls={ftps3ImageUrls}
                              imageLoadingStates={imageLoadingStates}
                              imageErrorStates={imageErrorStates}
                              imageOrientations={imageOrientations}
                              handleImageLoad={handleImageLoad}
                              handleImageError={handleImageError}
                              handleIngresar={handleIngresar}
                            />
                          ) : (
                            <div className="w-full h-full bg-gray-50" />
                          )}
                        <div className="project-title-overlay">
                          {project.Name}
                        </div>
                      </div>
                      <div className="project-button-bar">
                        <button onClick={() => handleIngresar(project.identifier)}>
                            <ArrowRight size={18} />
                           
                        </button>

                        {/*
                        <button onClick={() => handleDetails(project.id)}>
                            <Info size={18} /> 
                            
                        </button>
                        <button onClick={() => handleShare(project.id)}>
                            <Share2 size={18} /> 
                            
                        </button>
                        <button onClick={() => handleDownload(project.id)}>
                            <Download size={18} /> 
                            
                        </button>
                        */}
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            </div>


{modalOnboardOpen && (
  <OnboardingAndDeliveryScheduleStart
    isOpen={modalOnboardOpen}
    onClose={() => setModalOnboardOpen(false)}
    customerId={customerId.customerId}
  />
)}


          </main>
        </div>

        <FloatingWhatsAppButton message="Tengo una consulta." />

          <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />

      </div>
    </>
  );
}

export default CustomerDashboardStart;